import i18next from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import en from '@/app/translate/langs/en.json'
import vi from '@/app/translate/langs/vi.json'
import { KEY_LANGS, STORAGE_KEYS } from '@/shared/constants'

const language = localStorage.getItem(STORAGE_KEYS.LANGUAGE) ?? KEY_LANGS.VI

void i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    interpolation: { escapeValue: false },
    lng: language,
    fallbackLng: KEY_LANGS.VI,
    resources: {
      [KEY_LANGS.VI]: {
        translation: vi,
      },
      en: {
        translation: en,
      },
    },
  })

export default i18next
